document.addEventListener("DOMContentLoaded", function(){

const trigger = document.querySelector(".search-trigger");
const modal = document.querySelector(".search-modal");
const closeBtn = document.querySelector(".close-search");
const input = document.querySelector("#custom-search-input");
const pills = document.querySelectorAll(".filter-pill");
const resultsBox = document.querySelector("#live-search-results");

/* Always capture each pill's real label straight from the DOM at load time.
   The markup never sets a data-original-text attribute, so reading it here
   (instead of assuming it exists) is what previously produced literal
   "undefined" text once the search box was typed into and cleared. */
pills.forEach(function(pill){
  pill.dataset.originalText = pill.textContent.trim();
});

if(trigger){
trigger.addEventListener("click", () => {
modal.classList.add("open");
});
}

if(closeBtn){
closeBtn.addEventListener("click", () => {
modal.classList.remove("open");
});
}

let liveSearchTimer;

function renderLiveResults(products){

if(!resultsBox) return;

if(!products.length){
resultsBox.innerHTML = "<p class=\"live-search-empty\">No products found.</p>";
resultsBox.classList.add("has-results");
return;
}

resultsBox.innerHTML = products.map(function(p){
return "<a class=\"live-search-item\" href=\"" + p.url + "\">" +
  "<img src=\"" + (p.image || "") + "\" alt=\"\" loading=\"lazy\">" +
  "<span class=\"live-search-item__info\">" +
    "<span class=\"live-search-item__title\">" + p.title + "</span>" +
    "<span class=\"live-search-item__price\">$" + p.price + "</span>" +
  "</span>" +
"</a>";
}).join("");

resultsBox.classList.add("has-results");
}

function fetchLiveResults(query){

fetch("/search/suggest.json?q=" + encodeURIComponent(query) + "&resources[type]=product&resources[limit]=6")
.then(function(res){ return res.json(); })
.then(function(data){
var products = (data.resources && data.resources.results && data.resources.results.products) || [];
renderLiveResults(products);
})
.catch(function(){
if(resultsBox){
resultsBox.innerHTML = "";
resultsBox.classList.remove("has-results");
}
});

}

if(input){

input.addEventListener("input", function(){

let value = this.value.toLowerCase();

/* filter pills */
pills.forEach(pill => {

let text = pill.dataset.originalText || "";

if(!value){
pill.innerHTML = text;
pill.style.display = "";
return;
}

if(text.toLowerCase().includes(value)){

let regex = new RegExp(`(${value})`, "gi");

pill.innerHTML = text.replace(regex,"<b>$1</b>");

pill.style.display = "";

}else{

pill.style.display = "none";

}

});

/* live-as-you-type product results, no Enter required */
if(resultsBox){

clearTimeout(liveSearchTimer);

let query = this.value.trim();

if(query.length < 2){
resultsBox.innerHTML = "";
resultsBox.classList.remove("has-results");
return;
}

liveSearchTimer = setTimeout(function(){
fetchLiveResults(query);
}, 250);

}

});

}

});
document.addEventListener("click", function(e){

const pill = e.target.closest(".filter-pill");
const family = e.target.closest(".scent-family-card button");

if(pill){
let text = pill.dataset.originalText || pill.innerText;
window.location.href = `/search?q=${encodeURIComponent(text)}`;
}

if(family){
let text = family.dataset.family;
window.location.href = `/search?q=${encodeURIComponent(text)}`;
}

});
